import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import Icon from "../icons/Icon";

import "./ActionCard.scss";
import { createDataAttributes } from "../../utilities";

const ActionCard = ({
  disabled,
  onClick,
  icon,
  title,
  color,
  link,
  target,
  className,
  dataAttrib,
  dataWrapperAttrib,
  textAlign = "left"
}) => {
  const classes = classnames(
    "uikit__action-card",
    "uikit__action-card__" + color,
    {
      "uikit__action-card__disabled": disabled
    },
    className
  );
  const linkTarget = link ? target : null;
  const cardClasses = classnames(
    "uikit__action-card__card",
    "uikit__action-card__card--text-" + textAlign
  );
  const card = React.createElement(
    link ? "a" : "button", // component type
    {
      href: link,
      className: cardClasses,
      onClick,
      target: linkTarget,
      ...createDataAttributes(dataAttrib)
    }, // 'props'
    // element's 'children'
    <>
      {icon && (
        <span className="uikit__icon-wrapper uikit__action-card__icon">
          {React.isValidElement(icon) ? icon : <Icon icon={icon} />}
        </span>
      )}
      <span className="uikit__action-card__title">{title}</span>
    </>
  );
  return (
    <div className={classes} {...createDataAttributes(dataWrapperAttrib)}>
      {card}
    </div>
  );
};

ActionCard.propTypes = {
  onClick: propTypes.func,
  icon: propTypes.oneOfType([propTypes.string, propTypes.element]),
  title: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired,
  disabled: propTypes.bool,
  link: propTypes.string,
  target: propTypes.string,
  color: propTypes.oneOf([
    "lt-blue",
    "dk-blue",
    "green",
    "orange",
    "purple",
    "grey",
    "red"
  ]),
  className: propTypes.string,
  textAlign: propTypes.oneOf(["left", "right", "center"]),
  dataAttrib: propTypes.arrayOf(Object),
  dataWrapperAttrib: propTypes.arrayOf(Object)
};

ActionCard.defaultProps = {
  disabled: false,
  color: "green",
  onClick: () => {},
  target: "_self"
};

export default ActionCard;
